import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'

interface RankingItem {
  name: string
  department: string
  count: number
  /** 接口字段，用于抽屉列表 search_word */
  computer_name?: string
  user_mark?: string
  device_id?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'usb-access-ranking-chart',
  props: {
    data: { default: () => [] },
    timeRange: { default: 1 }
  },
  emits: ["update:timeRange", "change", "rowClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n()

const props = __props
const timePeriodOptions = computed(() => [
  { label: t('usbPolicy.all'), value: 1 },
  { label: t('usbPolicy.last24h'), value: 2 },
  { label: t('usbPolicy.last7d'), value: 3 },
  { label: t('usbPolicy.lastMonth'), value: 4 }
])
const emit = __emit

const timeRange = computed({
  get: () => props.timeRange,
  set: (val) => emit('update:timeRange', val)
})
const changeSelect = (val:number) => {
  emit('change',val)
}
const loading = ref(false)

function onItemClick(item: RankingItem) {
  emit('rowClick', item)
}

const rankingData = computed(() => {
  return props.data.map(item => ({
    name: item.name,
    department: item.department,
    count: item.count,
    computer_name: item.computer_name,
    user_mark: item.user_mark,
    device_id: item.device_id,
  }))
})

__expose({
  loading
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('usbPolicy.accessRankTitle'),
    data: rankingData.value,
    loading: loading.value,
    "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
    unit: _ctx.$t('usbPolicy.unitTimes'),
    "name-key": "name",
    "row-clickable": true,
    onItemClick: onItemClick
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    headerRight: _withCtx(() => [
      _createVNode(_component_el_select, {
        size: "mini",
        style: {"width":"120px"},
        modelValue: timeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
        onChange: changeSelect
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timePeriodOptions.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    "item-name": _withCtx(({ item }: { item: RankingItem & { rank: number } }) => [
      _createTextVNode(_toDisplayString(item.name) + " (" + _toDisplayString(item.department) + ") ", 1)
    ]),
    _: 1
  }, 8, ["title", "data", "loading", "unit"]))
}
}

})